const and = (a, b) => a && b;
export default and;
